import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { ICustomTextEntry } from '../custom_text_interface';
import { CustomTextModel } from '../models/custom_text_model';

export class CustomTextQuery implements IQuery {
  private _result: ICustomTextEntry[];

  constructor(private ngCustomTextModel: CustomTextModel) {
    Query.registerQuery(this, ngCustomTextModel);
  }

  run(): CustomTextQuery {
    const customText = this.ngCustomTextModel.read();
    this._result = _4.zipObject(_4.map(customText, 'nk'), _4.map(customText, 'text'));
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('data-ng-custom-text').service('ngCustomTextQuery', CustomTextQuery);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/queries/custom_text_query.ts